export const ORDERS_QUERY_VARIABLES = { input: { page: 1, take: 10 } };
